import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./Author.scss";

const Author = () => {
    const { file: avatar, site: { siteMetadata } } = useStaticQuery(graphql`
        {
          file(name: {eq: "avatar"}) {
            childImageSharp {
              fixed(width: 28, height: 28) {
                ...GatsbyImageSharpFixed_withWebp
              }
            }
          }
          site {
            siteMetadata {
              blog {
                author
              }
            }
          }
        }
    `);

    return (
        <div className="author">
            <Img fixed={avatar.childImageSharp.fixed} className="author__image" />
            <span className="author__name">by {siteMetadata.blog.author}</span>
        </div>
    );
};

export default Author;
